import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SmartDocsMode_Logs, SmartDocsMode_MDM, SmartDocsMode_Note } from './types.js';
import { Renderer_SmartLogs } from '../_renderers/Renderer_SmartLogs/Renderer_SmartLogs.js';
import { Renderer_QuickNote } from '../_renderers/Renderer_QuickNote/Renderer_QuickNote.js';
export const SmartDocsModes_LabelMap = {
    [SmartDocsMode_MDM]: 'MDM',
    [SmartDocsMode_Logs]: 'Logs',
    [SmartDocsMode_Note]: 'Quick Note',
};
export const SmartDocsMode_ComponentMap = {
    [SmartDocsMode_MDM]: () => _jsx(_Fragment, {}),
    [SmartDocsMode_Logs]: () => _jsx(Renderer_SmartLogs, {}),
    [SmartDocsMode_Note]: (onCloseCallback) => _jsx(Renderer_QuickNote, { onCloseEditor: onCloseCallback }),
};
//# sourceMappingURL=consts.js.map